module.exports = __webpack_public_path__ + "static/media/h2.4cd09046.png";